import { Component, OnInit } from '@angular/core';
declare var jQuery:any;
declare var Sortable:any;
@Component({
  selector: 'app-download-rapport',
  templateUrl: './download-rapport.component.html',
  styleUrls: ['./download-rapport.component.scss']
})
export class DownloadRapportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
(function ($){
  const dropItems = document.getElementById("drop-items");

new Sortable(dropItems, {
  animation: 350,
  chosenClass: "sortable-chosen",
  dragClass: "sortable-drag",
});
})(jQuery);


  }

  getData(){

    

  }



}
